import { Component, OnInit, inject } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-opcion-descarga',
  templateUrl: './opcion-descarga.component.html',
  standalone: false,
  styleUrls: ['./opcion-descarga.component.css']
})
export class OpcionDescargaComponent implements OnInit {
  modalRef = inject(DynamicDialogRef);
  modalConfig = inject(DynamicDialogConfig);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() { }

  ngOnInit(): void {    
  }

  public confirmarOpcion(formato: string) {
    this.modalRef.close(formato);
  }

  public cancelar() {
    this.modalRef.close();
  } 
}
